import styles from './scss/styles.scss';

const canvas = document.querySelector('canvas');
const ctx = canvas.getContext('2d');
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

const lines = 12;
let bits = [];

const drawMeasures = () => {
  const gridSpace = window.innerHeight / lines;

  for (let i = 0; i < lines; i++) {
    ctx.save();

    ctx.beginPath();
    ctx.moveTo(0, gridSpace * i);
    ctx.lineTo(window.innerWidth, gridSpace * i);
    ctx.strokeStyle = `rgba(80, 227, 194, ${i % 2 ? 0.025 : 0.05})`;
    ctx.stroke();

    ctx.restore();
  }
};

class Bit {
  constructor(context, x = 0, j = 1, width = 1, length = 10, vel = 10) {
    this.ctx = context;
    this.x = x;
    this.j = j;
    this.width = width;
    this.length = length;
    this.vel = vel;
    this.rapid = false;
  }

  update(delta) {
    this.x += (this.rapid ? this.vel * 32 : this.vel) * delta;
    this.x = this.x > window.innerWidth ? 0 - this.length : this.x;
    this.y = (window.innerHeight / lines) * this.j;

    if (Math.random() < 0.001) {
      this.rapid = !this.rapid;
    }

    if (Math.random() < 0.05) {
      this.rapid = false;
    }
  }

  draw() {
    this.ctx.save();

    this.ctx.beginPath();
    this.ctx.moveTo(this.x, this.y);
    this.ctx.lineTo(this.x + this.length, this.y);
    this.ctx.strokeStyle = this.rapid ? '#FFE474' : 'rgba(80, 227, 194, 1)';
    this.ctx.lineWidth = this.width;
    this.ctx.lineCap = 'round';

    //if (Math.random() < 0.01) {
    if (this.rapid) {
      this.ctx.lineWidth = this.width * 1.5;
      this.ctx.shadowBlur = this.width * 6;
      this.ctx.shadowColor = '#FFE474';
    }

    this.ctx.stroke();

    this.ctx.restore();
  }
}

const init = () => {
  bits = [];
  const qty = window.innerWidth > 768 ? 64 : 32;
  let j = 1;
  for (let i = 0; i < qty; i++) {
    bits.push(new Bit(
      ctx,
      Math.floor(window.innerWidth * Math.random()),
      j,
      1 * Math.ceil(Math.random() * 3),
      1 * Math.ceil(Math.random() * 6),
      1 * Math.ceil(Math.random() * 6)
    ));

    j = j < lines - 1 ? ++j : 1;
  }
};

let delta = 0;
let lastTime = 50;
const render = (timestamp) => {
  ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

  // When the window loses focus we get a large discrepancy between time measurements, so fix that.
  if (timestamp - lastTime >= 1000) {
    lastTime = timestamp - (60 / 1000);
  }
  // delta can be zero on first frame, so return 1.0 if 0
  delta = (timestamp - lastTime) / 1000 || 1.0;
  lastTime = timestamp;

  drawMeasures();

  for (let i = 0; i < bits.length; i++) {
    bits[i].update(delta);
    bits[i].draw();
  }

  requestAnimationFrame(render);
};

init();
render();

window.addEventListener('resize', () => {
  init();
  console.log('re-init on resize');
});



// WEBPACK FOOTER //
// ./src/app.js